import { render } from "./DateRangePicker.vue?vue&type=template&id=7af77fce"
import script from "./DateRangePicker.vue?vue&type=script&lang=js"
export * from "./DateRangePicker.vue?vue&type=script&lang=js"

import "flatpickr/dist/flatpickr.css?vue&type=style&index=0&lang=css"
script.render = render

export default script